import { VUE_APP_GOOGLE_API_KEY } from '@/utilities/constants.js';

export const MapMixin = {
  methods: {
    checkAndAttachMapScript: function(callback) {
      let scriptId = 'map-api-script';
      let mapAlreadyAttached = !!document.getElementById(scriptId);
      if (mapAlreadyAttached) {
        if (window.google)
          // Script attached but may not finished loading; so check for 'google' object.
          callback();
      } else {
        window.mapApiInitialized = callback;
        let script = document.createElement('script');
        script.id = scriptId;
        script.src = `https://maps.googleapis.com/maps/api/js?key=${VUE_APP_GOOGLE_API_KEY}&libraries=places,geometry&callback=mapApiInitialized`;
        document.body.appendChild(script);
      }
      return mapAlreadyAttached;
    },

    createClusterScripts() {
      const clusterScript = document.createElement('script');
      clusterScript.setAttribute(
        'src',
        'https://unpkg.com/@googlemaps/markerclustererplus/dist/index.min.js'
      );

      document.head.appendChild(clusterScript);
    }
  }
};
